import {isEmpty} from 'lodash'
import {getImageUrl, onError, message, errorHandler, logout, routeErrorHandler, loader} from '@/libs/helper'
import OrgFilter from '@/components/pages/InformationPortal/Organisation/OrgFilter/OrgFilter.vue'
import {getCollaboratorsList, removeCollaborator, changeCollaboratorRole} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'
import {mapGetters} from 'vuex'
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'

export default {
    name: 'OrgCollaborators',
    mixins: [OrganisationRolesErrorHandlerMixin],
    computed: {
        ...mapGetters({
            organisationRoles: 'getOrganisationRoles'
        })
    },
    components: {
        OrgFilter,
        InvitePeople: () => import("@/components/pages/InformationPortal/Organisation/InvitePeople/InvitePeople.vue")
    },
    props: {
        selectedCollection: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        selectedCollection () {
            this.fetchCollaboratorsList()
        }
    },
    mounted() {
        this.fetchCollaboratorsList()
    },
    data() {
        return {
            isEmpty,
            onError,
            getImageUrl,
            manageList: {},
            showDropdown: false,
            currentPage: 1,
            skip: 0,
            limit: 30,
            sort: 'name',
            order: 'desc',
            isInvite: false,
            collaboratorList: [],
            collaboratorData: {},
            columns: ['name', 'role', 'settings'],
            tableSettings: {
                headings: {
                  name: 'Name',
                  settings: '',
                  role: 'Rights',
                },
                pagination: {show: false},
                perPage: 30,
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
            },
            isChangeRole: false,
            selectedCollaboratorToUpdate: {},
        }
    },
    methods: {
        /**
         * fetch Collaborators list
         */
        fetchCollaboratorsList () {
            if (isEmpty(this.selectedCollection)) return
            // body for api
            let body = {
                list_for: this.selectedCollection.type === constants.LIST.REGULAR_COLLECTION ? constants.LIST.COLLECTION : constants.LIST.DOSSIER,
                entity_type: constants.ORGANISATIONS.ORGANISATION,
                list_id: this.selectedCollection._id,
                entity_id: this.$route.params.id
            }
            // api call
            getCollaboratorsList(body).then(response => {
                this.collaboratorData = response || {}
                this.collaboratorList = response.items || []
            })
            .catch(error => {
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
            })
        },
        /**
         * handle command
         */
        handleCommand (option, data) {
            switch (option) {
                case 'DELETE':
                    this.deleteCollaborator(data)
                break
                case 'CHANGE_RIGHT':
                    this.selectedCollaboratorToUpdate = data
                    this.updateCollaboratorRole()
                break
            }
        },
        /**
         * to change the pages 
         * @param {*} currentPage 
         */
        changePage (currentPage) {
            this.currentPage = currentPage
            // setting the skip as per the current page
            this.skip = (currentPage - 1) * this.limit
            // call for fetching the articles
            this.fetchCollaboratorsList()
        },
        closeInviteDialog () {
            this.isInvite = false
        },
        /**
         * to delete the collaborator
         */
        deleteCollaborator (collaborator) {
            const mainTitle = `${window.i18next.t(`Remove collaborator`)} `;
            const nameTitle = `${collaborator.first_name} ${collaborator.last_name}`;
            // html for popup
            const html =
                `<div class="remove-body remove-people">
                    <div class="popup-title remove-title"><span>
                    ` + mainTitle +`
                    </span>: <span class="listing-name">
                    ` + nameTitle + `
                    </span></div>
                    <div class="warning-text-container remove-warning">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                            ${window.i18next.t('When you remove a collaborator, you can no longer make any changes to it')}.
                        </div>
                    </div>
                    <div class="warning-confirmation-text remove-warn">
                        ${window.i18next.t('Are you sure you would like to remove the collaborator, it can not be undone')}?
                    </div>                    
                </div>`
                // confirmation box
                this.$confirm(`${html}`, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: window.i18next.t('Remove'),
                    cancelButtonText: window.i18next.t('Cancel'),
                    showClose: false,
                    closeOnClickModal: false,
                    customClass: 'remove-team-popup',
                    confirmButtonClass: 'primary-button confirm mini-button',
                    cancelButtonClass: 'primary-button mini-button'
                }).then(async() => {
                    loader(this, true)
                    // api all
                    try {
                        let body = {
                            entity_type: constants.LIST.COLLECTION,
                            entity_id: this.selectedCollection._id,
                            member: collaborator._id,
                            organisation: this.$route.params.id,
                        }
                        let response = await removeCollaborator(body)
                        if (response.success) {
                            this.fetchCollaboratorsList()
                            message(this, constants.messageType.SUCCESS, 'Collaborator removed successfully')
                        }
                    } catch (error) {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                        // error handler for permissions
                        this.rolesErrorHandler(error)
                    }
                    loader(this, false)
                    
                }).catch((error) => {
                    console.error('--', error)
                })
            },
            /**
         * to update the role of collaborator
         */
        async updateCollaboratorRole () {
            try {
                loader(this, true)
            // body for api
            let body = {
                entity_type: constants.LIST.COLLECTION,
                entity_id: this.selectedCollection._id,
                member: this.selectedCollaboratorToUpdate._id,
                organisation: this.$route.params.id,
            }
            // api call
            let response = await changeCollaboratorRole(body)
            if (response.success) {
                this.collaboratorList = this.collaboratorList.map(list => {
                    if (list._id === this.selectedCollaboratorToUpdate._id) list.role = list.role === 'View' ? 'Edit' : 'View'
                    return list
                })
                message(this, constants.messageType.SUCCESS, 'Collaborator role changed successfully')
            }
            } catch (error) {
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                // error handler for permissions
                this.rolesErrorHandler(error)
            }
            loader(this, false)
        },
    }
}